import { newModal, mergeModalState } from "@js/helpers/state.js";
import {
  CE_PROMPT_CHANGE_INTERFACE,
  CE_PROMPT_CHANGE_INTERFACE_ERROR,
} from "@js/actions/studio/campaign_content_section/modal_prompt_change_interface.js";

export default (state = {}, action) => {
  switch (action.type) {
    case CE_PROMPT_CHANGE_INTERFACE:
      return newModal(state, "prompt_change_interface", {
        campaign_id: state.campaign_id,
        custom_warning: state.library.use_v1_editor_warning || "",
        use_v1_editor: state.library.use_v1_editor,
      });
    case CE_PROMPT_CHANGE_INTERFACE_ERROR:
      return mergeModalState(state, {
        validation_error: action.validation_error,
      });
    default:
      return state;
  }
};
